export class InputCssClasses {
    public static ValidCssClass: string = "is-valid";
    public static InvalidCssClass: string = "is-invalid";
}